import React from "react"
import { getIn } from "formik"
import FormLabel from "./formLabel"
import * as CommonFunction from "../../common/function"
import NumberFormat from "react-number-format"

function FormDateInputTextbox(props) {
  const { textDesc, form, field, maxLength } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <div className="marginBottom19px">
      <div>
        <FormLabel text={textDesc} />
      </div>
      <div>
        <div className="marginTop10px">
          <NumberFormat
            name={field.name}
            placeholder="DD/MM/YYYY"
            className={
              "d-block inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            format={CommonFunction.dateFormat}
            onChange={form.handleChange}
            maxLength={maxLength}
            autoComplete="new-password"
            value={field.value ? field.value : ""}
          />
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </div>
      </div>
    </div>
  )
}
export default FormDateInputTextbox
